/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type AppliesToWeek = (typeof AppliesToWeek)[keyof typeof AppliesToWeek];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AppliesToWeek = {
  ODD_WEEKS: 0,
  EVEN_WEEKS: 100,
} as const;
